module.exports = __webpack_public_path__ + "assets/img/wolf-trap.93ca8f1e.png";